import React, { useState, useRef, useEffect } from 'react';
import { useStyles } from '../../../lib/hooks/useStyles';
import theme from '../../../lib/themes/linkpick/new_theme';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const Select = ({
  value,
  onChange,
  name,
  error,
  options,
  getOptionLabel,
  placeholder = "Sélectionnez une option",
  disabled = false,
  required = false,
  className,
  style,
  passOptionObject = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const { css } = useStyles(styles);
  const selectRef = useRef(null);

  useEffect(() => {
    if (!isDropdownOpen) return;
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const selectedOption = passOptionObject ? value : options?.find(option => option.value === value);

  return (
    <div ref={selectRef} className={css(theme.components.select.container)}>
      <div 
        className={css(
          theme.components.select.input,
          error && theme.components.select.error,
          isHovered && theme.components.select.hover,
          isFocused && theme.components.select.focus
        )}
        style={style}
        onClick={() => !disabled && setIsDropdownOpen(!isDropdownOpen)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <span className={css(
          theme.components.select.placeholder,
          disabled && theme.components.select.placeholderDisabled
        )}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span className={css(theme.components.select.arrow)}>
          <KeyboardArrowDownIcon />
        </span>

        {/* Dropdown des options */}
        {isDropdownOpen && !disabled && (
          <div className={css(theme.components.select.dropdown)}>
            {options?.map((option) => (
              <div
                key={option.value}
                onClick={() => {
                  if (passOptionObject) {
                    onChange && onChange(option);
                  } else {
                    onChange && onChange({
                      target: {
                        name,
                        value: option.value
                      }
                    });
                  }
                  setIsDropdownOpen(false);
                }}
                onMouseEnter={() => setHoveredOption(option.value)}
                onMouseLeave={() => setHoveredOption(null)}
                className={css(
                  theme.components.select.option,
                  (value === option.value || hoveredOption === option.value) && theme.components.select.optionSelected
                )}
              >
                <span className={css(theme.components.select.optionText)}>
                  {getOptionLabel ? getOptionLabel(option) : option.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = () => ({
  container: theme.components.select.container,
  input: theme.components.select.input
});

export default Select; 